<template>
  <v-sparkline
    style="width:100%;height: 100%; display: inline-block"
    radius="0"
    padding="8"
    line-width="3"
    :value="getOnlineData"
    auto-draw
    responsive="false"
    color="#42B3F4"
    width="600"
  ></v-sparkline>
</template>
<script>
var moment = require("moment");
export default {
  name: "MySparkline",
  props: {
    data: Array
  },
  data() {
    return {
      delta: 0
    };
  },
  computed: {
    getOnlineData(data) {
      var self = this;
      if (self.data.length > 0) {
        for (var i = 0; i < 23 - moment().format("HH"); i++) {
          self.data.unshift(self.data.pop());
        }
      }
      if (self.delta && self.delta > 0) {
        for (var i = 0; i < self.data.length; i++) {
          if (self.data[i] > 0) {
            self.data[i] = self.data[i] - self.delta;
          }
          if (self.data[i] < 0) self.data[i] = 0;
        }
      }

      return self.data;
    }
  }
};
</script>
<style scoped>
</style>






// WEBPACK FOOTER //
// src/components/charts/MySparkline.vue